<template>
    <div>
        <slot />
    </div>
</template>
<script>


export default {
    name: "NoLayout",
}
</script>


// WEBPACK FOOTER //
// src/layouts/central/NoLayout.vue